import {WebsiteSidebarSimpleItemType} from "../website-sidebar-simple-item/website-sidebar-simple-item.director";

export interface IWebsiteSidebarSubMenuData {
  name: string;
  label: string;
  type: 'static' | 'dropdown' | 'accordion';
  img?: string;
  icon?: string;
  subMenu?: WebsiteSidebarSimpleItemType[];
  pageIds?: string[];
  disabled?: boolean;
  beta?: boolean;
  hasNotice?: boolean;
  advanced?: boolean;
}

export const WEBSITE_SIDEBAR_SUB_MENUS_DATA: { [key: string]: IWebsiteSidebarSubMenuData } = {
  hostingLive: {name: 'hosting', label: 'text_hosting.title', type: 'dropdown',
    icon: 'db-icon-ds-sidebar-hosting',
    advanced: true,
    subMenu: ['credentials', 'tools',  'staging', 'redirects', 'resource', 'logs'],
    pageIds: ['hosting-tools', 'hosting-info', 'redirects', 'hosting-resource-usage', 'logs', 'environment']},

  hostingLiveStagingEnabled: {name: 'hosting', label: 'text_hosting.title', type: 'dropdown',
    icon: 'db-icon-ds-sidebar-hosting',
    advanced: true,
    subMenu: ['credentials', 'tools', 'stagingEnabled', 'redirects', 'resource',  'logs' ],
    pageIds: ['hosting-tools', 'hosting-info', 'redirects', 'hosting-resource-usage', 'logs' ]},

  hostingDev: {name: 'hosting', label: 'text_hosting.title', type: 'dropdown',
    icon: 'db-icon-ds-sidebar-hosting',
    advanced: true,
    subMenu: ['credentials', 'tools', 'redirects', 'resource', 'manage', 'logs'],
    pageIds: ['hosting-tools', 'manage-environment', 'hosting-info', 'redirects', 'hosting-resource-usage', 'environment', 'logs' ]},

  booster: {name: 'booster', label: 'text_speedOptimizer', type: 'dropdown' ,
    icon: 'db-icon-ds-sidebar-booster',
    advanced: true,
    subMenu: ['boosterMain', 'boosterPages', 'boosterImageOptimizer', 'boosterHostingPerformance', 'boosterSettings'],
    pageIds: ['frontend', 'pages', 'booster-image-optimizer', 'image-optimizer', 'hosting-performance', 'pro', 'settings', 'boosterDisconnected']},

  boosterOnly: {name: 'booster', label: 'text_speedOptimizer', type: 'static' ,
    icon: 'db-icon-ds-sidebar-booster',
    advanced: true,
    subMenu: ['boosterMain', 'boosterPages', 'boosterImageOptimizer', 'boosterHostingPerformance', 'boosterSettings', 'boosterWhiteLabel'],
    pageIds: ['frontend', 'pages', 'image-optimizer', 'booster-image-optimizer', 'hosting-performance', 'pro', 'settings', 'white-label', 'boosterDisconnected']},

  boosterDev: {name: 'boosterDev', label: 'text_speedOptimizer', type: 'dropdown',
    icon: 'db-icon-ds-sidebar-booster',
    advanced: true,
    subMenu: ['boosterMain', 'boosterPages', 'boosterImageOptimizer', 'boosterHostingPerformance', 'boosterSettings'],
    pageIds: ['frontend', 'pages', 'image-optimizer', 'booster-image-optimizer', 'hosting-performance', 'settings', 'boosterDisconnected']},

  boosterDisabled: {name: 'boosterDisabled', label: 'text_speedOptimizer', type: 'dropdown' ,
    icon: 'db-icon-ds-sidebar-booster',
    advanced: true,
    subMenu: ['boosterMainDisabled'],
    pageIds: ['frontend', 'boosterDisconnected']},

  boosterDisabledDev: {name: 'boosterDisabledDev', label: 'text_speedOptimizer', type: 'dropdown' ,
    icon: 'db-icon-ds-sidebar-booster',
    advanced: true,
    subMenu: ['boosterMain'],
      pageIds: ['frontend', 'boosterDisconnected']},

  hostingParentSubFolder: {name: 'hosting', label: 'text_hosting.title', type: 'dropdown',
    icon: 'db-icon-ds-sidebar-hosting',
    advanced: true,
    subMenu: ['credentials', 'tools', 'redirects', 'resource', 'logs'],
    pageIds: ['hosting-info', 'hosting-tools', 'redirects', 'hosting-resource-usage', 'logs']},

  hostingParentSubDomain: {name: 'hosting', label: 'text_hosting.title', type: 'dropdown',
    icon: 'db-icon-ds-sidebar-hosting',
    advanced: true,
    subMenu: ['credentials', 'tools', 'resource', 'logs'],
    pageIds: ['hosting-info', 'hosting-tools', 'hosting-resource-usage', 'logs']},

  hostingChildSubFolder: {name: 'hosting', label: 'text_hosting.title', type: 'dropdown',
    icon: 'db-icon-ds-sidebar-hosting',
    advanced: true,
    subMenu: ['redirects'],
    pageIds: ['redirects']},

  hostingChildSubDomain: {name: 'hosting', label: 'text_hosting.title', type: 'dropdown',
    icon: 'db-icon-ds-sidebar-hosting',
    advanced: true,
    subMenu: ['tools', 'redirects'],
    pageIds: ['hosting-tools', 'redirects']},

  ecommerceActive: {name: 'ecommerce', label: 'text_ecommerce.title', type: 'dropdown',
    advanced: true,
    icon: 'db-icon-ds-sidebar-ecommerce',
    pageIds: [ 'overview', 'products-list', 'add-product', 'edit-product',  'payment-methods', 'tax', 'orders-list', 'order-view', 'customers-list', 'customer-view', 'emails', 'ecommerce-settings'],
    subMenu: ['overview',  'orders', 'products', 'customers', 'paymentMethods', 'tax', 'emails',  'shipping', 'settings']},

  products: {name: 'products', label: 'text_managerPluginsThemes', type: 'dropdown',
    icon: 'db-icon-ds-sidebar-products',
    advanced: true,
    pageIds: ['installed-plugins', 'installed-add-ons'],
    subMenu: ['plugins', 'themes']},
};
